import React, { Component } from 'react'
import '../OnlineHelpPage.css'
import Station from './img/Station.png'

export default class StationPosition extends Component {
  render() {
    return (
      <div className="main-window">
      <div className="main-window-title">使用场站定位功能</div>
      <img src={Station} className="main-window-img"></img>
    </div>
    )
  }
}
